// Hook: useMaterialAggregation
// Extracts aggregation of selected materials and fast lookup maps
import { useMemo } from "react";

export default function useMaterialAggregation(sampleBundles = []) {
  const aggregatedMaterials = useMemo(() => {
    const aggregate = {};
    sampleBundles.forEach((rec) => {
      const comboKey = `${rec.hardwareId}|${rec.subscriptionId}`;
      if (!aggregate[comboKey]) {
        aggregate[comboKey] = {
          hardwareId: rec.hardwareId,
          hardwareName: rec.hardwareName,
          subscriptionId: rec.subscriptionId,
          subscriptionName: rec.subscriptionName,
          techRefId: rec.techRefId,
          requestedQuantity: 0,
          bundleIds: new Set(),
          workticketIds: new Set(),
          esns: new Set(),
        };
      }
      aggregate[comboKey].requestedQuantity += 1;
      if (rec.bundleId) aggregate[comboKey].bundleIds.add(rec.bundleId);
      if (rec.workTicketId) aggregate[comboKey].workticketIds.add(rec.workTicketId);
      if (rec.esn) aggregate[comboKey].esns.add(rec.esn);
    });
    return Object.values(aggregate).map((m) => ({
      ...m,
      bundleIds: Array.from(m.bundleIds),
      workticketIds: Array.from(m.workticketIds),
      esns: Array.from(m.esns),
    }));
  }, [sampleBundles]);

  const materialsByKey = useMemo(() => {
    const map = {};
    aggregatedMaterials.forEach((m) => {
      map[`${m.hardwareId}|${m.subscriptionId}`] = m;
    });
    return map;
  }, [aggregatedMaterials]);

  const firstKey = useMemo(() => {
    return aggregatedMaterials.length ? `${aggregatedMaterials[0].hardwareId}|${aggregatedMaterials[0].subscriptionId}` : "";
  }, [aggregatedMaterials]);

  return { aggregatedMaterials, materialsByKey, firstKey };
}
